import * as React from "react";
import * as ReactDOM from "react-dom";

interface ITextColumnProperties
{
    text: string;
    width: number;
}

export class TextColumn extends React.Component<ITextColumnProperties>
{
    public static defaultProps: Partial<ITextColumnProperties> = {
        text: "",
        width: 180
    };

    constructor(props: ITextColumnProperties)
    {
        super(props);
    }

    render()
    {
        return (
            <div
                className="n-table_cell"
                style={{
                    width: this.props.width
                }}>
                <span className="n-table_cell_text">{this.props.text}</span>
            </div>
        );
    }
}